var EventType;
(function(EventType) {
    EventType["GA"] = "gaEvent";
    EventType["PAGE_VIEW"] = "pageview";
    EventType["CUSTOM_CRITEO"] = "fireCriteoTag";
})(EventType || (EventType = {}));
var EventCategory;
(function(EventCategory) {
    EventCategory["INDEX"] = "index";
    EventCategory["ACCOUNT_LOGIN"] = "account/login";
    EventCategory["SEARCH_HISTORY"] = "searchHistory";
    EventCategory["TOOLTIP"] = "tooltip";
    EventCategory["ROUNDTRIP"] = "roundtrip";
    EventCategory["NAVIGATION"] = "navigation";
    EventCategory["DRIVERAGE"] = "driverage";
    EventCategory["CONFIENZA"] = "confienza";
    EventCategory["FAQ"] = "faq";
    EventCategory["SEARCH_BUTTON_OFFERBOX"] = "search_button_offerbox";
    EventCategory["CUSTOMER_REVIEW"] = "customer_review";
    EventCategory["APP_ICON"] = "app_icon";
    EventCategory["SOCIAL_MEDIA_ICON"] = "social_media_icon";
    EventCategory["GENERAL_FOOTER_LINKS"] = "general_footer_links";
    EventCategory["NEWSLETTER_REGISTRATION"] = "newsletter/registration";
    EventCategory["ALL"] = "all";
    EventCategory["QR_CODE_BANNER"] = "qr_code_banner";
    EventCategory["INFO_BANNER"] = "info_banner";
    EventCategory["WEB_VITALS"] = "web_vitals";
    EventCategory["STATIONS_MAP"] = "stations_map";
})(EventCategory || (EventCategory = {}));
var EventAction;
(function(EventAction) {
    EventAction["CLICK"] = "click";
    EventAction["CLICK_PHONE_TOOLTIP_VOUCHER_LINK"] = "clickPhoneTooltipVoucherLink";
    EventAction["HOVER"] = "hover";
    EventAction["LOGIN_LOGOUT"] = "login_logout";
    EventAction["LOGIN_MENU"] = "login_menu";
    EventAction["LOGIN_MENU_CREATE_ACCOUNT"] = "login_menu_create_account";
    EventAction["LOGIN_MENU_FORGOTPWD"] = "login_menu_forgotpwd";
    EventAction["LOGIN_MENU_LOGIN"] = "login_menu_login";
    EventAction["LOGIN_MENU_MYBOOKINGS"] = "login_menu_mybookings";
    EventAction["LOGIN_MENU_MYDATA"] = "login_menu_mydata";
    EventAction["LOGIN_MENU_MYPAYMENT"] = "login_menu_mypayment";
    EventAction["MASTERCARD_CARIGAMI_CLICKED"] = "mastercard_carigami_clicked";
    EventAction["MASTERCARD_CARIGAMI_SEEN"] = "mastercard_carigami_seen";
    EventAction["ONEWAY_SELECT"] = "oneway_select";
    EventAction["SEARCHFORM_MORE_OPTIONS"] = "searchform_more_options";
    EventAction["SEARCHFORM_MORE_OPTIONS_FILTER_CLICK"] = "searchform_more_options_filter_click";
    EventAction["SELECT"] = "select";
})(EventAction || (EventAction = {}));
var EventLabel;
(function(EventLabel) {
    EventLabel["LOGGED"] = "logged";
    EventLabel["UNLOGGED"] = "unlogged";
    EventLabel["OPEN"] = "open";
    EventLabel["CLOSED"] = "closed";
})(EventLabel || (EventLabel = {}));
var CriteoPageType;
(function(CriteoPageType) {
    CriteoPageType["Homepage"] = "Homepage";
})(CriteoPageType || (CriteoPageType = {}));
var CriteoSiteType;
(function(CriteoSiteType) {
    CriteoSiteType["desktop"] = "d";
})(CriteoSiteType || (CriteoSiteType = {}));
var environments = {
    live: "live",
    dev: "dev"
};
export { CriteoPageType, CriteoSiteType, EventType, EventCategory, EventAction, EventLabel };
